export function checkForNewVersion(): void {
  if (__APP_VERSION__ === "dev") return;

  fetch("/version.json", { cache: "no-store" })
    .then((response) => {
      if (!response.ok) return;
      return response.json();
    })
    .then((data) => {
      if (!data) return;
      if (data.version !== __APP_VERSION__) {
        window.location.reload();
      }
    })
    .catch(() => {});
}
